import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').TableBlock}
 */
const Table = ({
    table = null,
    title = '',
}) => {
    return (
        <section className='flex flex-col gap-16 col-padding rounded-lg'>
            {title && (
                <h2 className='type-style-sans-h1 w-full md:w-7/12'>
                    {title}
                </h2>
            )}

            {table?.length > 0 && (
                <div className='w-full overflow-scroll'>
                    <table className='table-auto border-collapse border-spacing-0 overflow-hidden'>
                        <thead className='bg-neutral-100 text-left type-style-sans-body-med'>
                            <tr>
                                {table[0]?.map((td, idx) => {
                                    return (
                                        <th
                                            className='p-8 sm:p-16 border border-border-default whitespace-nowrap'
                                            key={idx}>
                                            <p>{td}</p>
                                        </th>
                                    );
                                })}
                            </tr>
                        </thead>

                        <tbody className='text-left type-style-sans-body'>
                            {table.map((tr, idx) => {
                                if (idx === 0) { return; }

                                return (
                                    <tr key={idx}>
                                        {tr?.map((td, jdx) => {
                                            return (
                                                <td
                                                    className='p-16 border border-border-default'
                                                    key={jdx}>
                                                    <p>{td}</p>
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            }).filter(Boolean)}
                        </tbody>
                    </table>
                </div>
            )}
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Table;
